import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDEwQcJxmBeIeTqV78NxmjhwHTvW5fBGwo",
  authDomain: "petaar-3dcab.firebaseapp.com",
  projectId: "petaar-3dcab",
  storageBucket: "petaar-3dcab.firebasestorage.app",
  messagingSenderId: "681043251925",
  appId: "1:681043251925:web:746cdd400a9ed31a6e085c",
  measurementId: "G-PG6B4MRYP2"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
